module.exports = __webpack_public_path__ + "static/media/logo_orange.ab5c991e.png";


//////////////////
// WEBPACK FOOTER
// ./src/component/header/images/logo_orange.png
// module id = 130
// module chunks = 4